// @owners { team: patients }
import { createSelector } from 'reselect';
import { getDeliveries } from './getDeliveries';

export const getUpcomingDeliveries = createSelector([getDeliveries], (deliveries) => {
  return deliveries.filter(({ status }) => status === 'upcoming');
});
